import React, {Component} from "react"
import styled, { css } from "styled-components"
import HeaderAnnouncement from "./HeaderAnnouncement"
import NavBar from "./NavBar"
// import NavFull from "./NavFull"
// import BellyBand from "./BellyBand";
// import BellyBandTemp from "./BellyBandTemp";

const HeaderWrap = styled.header`
    position: sticky;
    width: 100%;
    transform: translateY(0);
    top: 0;
    left: 0;
    z-index: 100;
    transition: all .4s ease-in-out;
    opacity: 1;
    visibility: visible;

    ${props => props.headerHidden && css`
        opacity: 0;
        visibility: hidden;
    `}
`

class Header extends Component {

    constructor(props) {
        super(props)

        this.state = {
            adHeight: 50,
            headerHidden: false,
            lastScrollTop: 0
        }

        this.calculateAdHeight = this.calculateAdHeight.bind(this)
        this.hideShow = this.hideShow.bind(this)
    }

    componentDidMount() {
        this.calculateAdHeight()
        window.addEventListener('resize', this.calculateAdHeight, true)
        window.addEventListener("scroll", this.hideShow, {passive: true})
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.hideShow, { passive: true })
    }

    hideShow() {
        let { lastScrollTop } = this.state
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollDirection = scrollTop > lastScrollTop ? "down" : "up"
        let headerHidden

        if (window.innerWidth < 768) {
            if (Math.abs(scrollTop - lastScrollTop) > 200) {
                if (scrollDirection === "up") {
                    headerHidden = false
                } else {
                    headerHidden = true
                }
    
                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    
                this.setState({
                    headerHidden,
                    lastScrollTop
                })
            }
        }
    }

    calculateAdHeight() {
        const width = window.innerWidth
        let adHeight
        if (width >= 992) {
            adHeight = 250 + 20
        } else if (width < 992 && width >= 768) {
            adHeight = 90 + 10
        } else {
            adHeight = 50 + 10
        }

        this.setState({
            adHeight
        })
    }

    render() {
        return (
            <>
                {/* <BellyBand 
                    style={{ height: `${this.state.adHeight}px` }} 
                    googleAds={this.props.googleAds} 
                /> */}
                {/* <BellyBandTemp /> */}
                <HeaderWrap className="headerWrap" id="siteHeader" headerHidden={this.state.headerHidden}>
                    <HeaderAnnouncement/>
                    <NavBar path={this.props.path} />
                </HeaderWrap>
                {/* <NavFull active={this.state.navActive} toggleNav={(e) => this.toggleNav(e)}/> */}
            </>
        )
    }
}

export default Header